import { unwrap } from "@nexxt/api-client";
import { queryOptions } from "@tanstack/react-query";
import { api } from "../../api";

/** The organization of who signed in, as party tells it (ADR-157): its name and whether it is a brand, a supplier. */
export const ownOrganizationQuery = queryOptions({
  queryKey: ["party", "own-organization"],
  queryFn: () => unwrap(api.party["own-organization"].$get()),
  staleTime: 5 * 60_000,
});

/** The tabs of the page of the organization, in the URL (`?tab=`). */
export const organizationTabs = ["details", "users", "contacts"] as const;
